// DO NOT EDIT -- generated from fs/services/search-settings/funnels.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as metrics from '../../api/metrics';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from './visualizationsettings';

export namespace Funnels {

  export const GetAllFunnelsEndpoint = "/grpc/search_settings.Funnels/GetAllFunnels";
  /**
   * Get all current non-archived funnels for an org.
   * If desired, archived funnels can also be retrieved with the explicit request flag.
   */
  export function GetAllFunnels(sender: (req: GetAllFunnelsRequest, endpoint: string) => Promise<GetAllFunnelsResponse>, req: GetAllFunnelsRequest): { promise: () => Promise<GetAllFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllFunnelsEndpoint),
      endpoint: GetAllFunnelsEndpoint
    };
  }

  export const GetFunnelEndpoint = "/grpc/search_settings.Funnels/GetFunnel";
  /** Get a specific funnel, either current or past version. */
  export function GetFunnel(sender: (req: GetFunnelRequest, endpoint: string) => Promise<GetFunnelResponse>, req: GetFunnelRequest): { promise: () => Promise<GetFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelEndpoint),
      endpoint: GetFunnelEndpoint
    };
  }

  export const BatchGetFunnelsEndpoint = "/grpc/search_settings.Funnels/BatchGetFunnels";
  export function BatchGetFunnels(sender: (req: BatchGetFunnelsRequest, endpoint: string) => Promise<BatchGetFunnelsResponse>, req: BatchGetFunnelsRequest): { promise: () => Promise<BatchGetFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetFunnelsEndpoint),
      endpoint: BatchGetFunnelsEndpoint
    };
  }

  export const SetFunnelEndpoint = "/grpc/search_settings.Funnels/SetFunnel";
  /** Add a new funnel or update an existing funnel. */
  export function SetFunnel(sender: (req: SetFunnelRequest, endpoint: string) => Promise<SetFunnelResponse>, req: SetFunnelRequest): { promise: () => Promise<SetFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetFunnelEndpoint),
      endpoint: SetFunnelEndpoint
    };
  }

  export const ArchiveFunnelEndpoint = "/grpc/search_settings.Funnels/ArchiveFunnel";
  /**
   * Archive an existing funnel for an org.
   * Once archived, the funnel cannot be modified and will not show up in GetAllFunnels unless explicitly requested.
   */
  export function ArchiveFunnel(sender: (req: ArchiveFunnelRequest, endpoint: string) => Promise<ArchiveFunnelResponse>, req: ArchiveFunnelRequest): { promise: () => Promise<ArchiveFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveFunnelEndpoint),
      endpoint: ArchiveFunnelEndpoint
    };
  }

  export const UnarchiveFunnelEndpoint = "/grpc/search_settings.Funnels/UnarchiveFunnel";
  /**
   * Unarchives an existing funnel for an org.
   * Once unarchived, the funnel can continue to be modified and will show up in GetAllFunnels.
   */
  export function UnarchiveFunnel(sender: (req: UnarchiveFunnelRequest, endpoint: string) => Promise<UnarchiveFunnelResponse>, req: UnarchiveFunnelRequest): { promise: () => Promise<UnarchiveFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveFunnelEndpoint),
      endpoint: UnarchiveFunnelEndpoint
    };
  }

  export const GetFunnelsAccessEndpoint = "/grpc/search_settings.Funnels/GetFunnelsAccess";
  export function GetFunnelsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelsAccessEndpoint),
      endpoint: GetFunnelsAccessEndpoint
    };
  }

  export const InvalidateCachedFunnelEndpoint = "/grpc/search_settings.Funnels/InvalidateCachedFunnel";
  export function InvalidateCachedFunnel(sender: (req: InvalidateCachedFunnelRequest, endpoint: string) => Promise<{}>, req: InvalidateCachedFunnelRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, InvalidateCachedFunnelEndpoint),
      endpoint: InvalidateCachedFunnelEndpoint
    };
  }
}

export namespace FunnelsPublic {

  export const GetFunnelsAccessEndpoint = "/grpc/search_settings.FunnelsPublic/GetFunnelsAccess";
  export function GetFunnelsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelsAccessEndpoint),
      endpoint: GetFunnelsAccessEndpoint
    };
  }
}

export interface GetAllFunnelsRequest {
  orgId: string;
  /** If true, archived funnels will also be returned. */
  includeArchived: boolean;
  /** By default, only public funnels are returned */
  includePrivate: boolean;
}

export interface GetAllFunnelsResponse {
  funnels: FunnelRecord[];
}

export interface GetFunnelRequest {
  /** required */
  orgId: string;
  /** required */
  funnelId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetFunnelResponse {
  versions: FunnelRecord[];
}

export interface BatchGetFunnelsRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetFunnelsRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetFunnelsRequest {
  export interface Identifier {
    /** required */
    funnelId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned */
    version: protobuf.int64;
  }
}

export interface BatchGetFunnelsResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found funnels will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetFunnelsResponse.Result[];
}

export namespace BatchGetFunnelsResponse {
  export interface Result {
    identifier: BatchGetFunnelsRequest.Identifier | null;
    versions: FunnelRecord[];
  }
}

export interface SetFunnelRequest {
  orgId: string;
  /**
   * Funnel to be created or updated.
   * If the id field is not set, an id will be generated and a new funnel will be stored.
   * TODO(clay - once client cuts over): If the id field is set, an existing funnel must already be persisted.
   */
  funnel: Funnel | null;
  isDcmCreated: boolean;
  visibility: protoauditstore.Visibility;
}

export interface SetFunnelResponse {
  funnel: FunnelRecord | null;
}

export interface ArchiveFunnelRequest {
  orgId: string;
  funnelId: string;
}

export interface ArchiveFunnelResponse {
  funnel: FunnelRecord | null;
}

export interface UnarchiveFunnelRequest {
  orgId: string;
  funnelId: string;
}

export interface UnarchiveFunnelResponse {
  funnel: FunnelRecord | null;
}

export interface InvalidateCachedFunnelRequest {
  orgId: string;
  funnelId: string;
}

export interface Funnel {
  id: string;
  name: string;
  description: string;
  events: segment.EventSequence | null;
  funnelSettings: visualizationsettings.ConversionFunnelSettings | null;
  aggregation: metrics.UniqueAggregation;
}

export interface FunnelRecord {
  funnel: Funnel | null;
  metadata: protoauditstore.AuditMetadata | null;
  /**
   * Whether this metric was created as part of the dashboard card migration.
   * Temporary field to be removed after DCM is rolled out.
   * See https://docs.google.com/document/d/1HYT7HIQpbP4SbSgzy6oIYAzCCzRUxoeuotNPr8ZYveg/edit#
   */
  isDcmCreated: boolean;
}
